export const CATEGORIES = {
  "movimento-terra": {
    slug: "movimento-terra",
    name: "Movimento Terra",
    eyebrow: "Scavo · Trasporto · Carico",
    short: "Escavatori compatti, dumper cingolati e minipale per scavi, sbancamenti e movimentazione materiali in cantiere.",
    description:
      "Mezzi compatti e potenti, ideali per cantieri urbani e spazi ristretti. Tutti gli escavatori Wacker Neuson sono a coda zero o ridotta, con cingoli in gomma per lavorare senza danneggiare pavimentazioni.",
    image: "/images/mezzi/wn-lineup.jpg",
    imagePosition: "center 60%",
    accent: "#FF6B00",
  },
  sollevamento: {
    slug: "sollevamento",
    name: "Sollevamento",
    eyebrow: "Piattaforme aeree · Scissor",
    short: "Piattaforme a forbice elettriche e piattaforme aeree autocarrate fino a 24 metri, guidabili con patente B.",
    description:
      "Dalle forbici elettriche per interni alle piattaforme autocarrate su Iveco Daily e Isuzu: soluzioni per lavori in quota su facciate, impianti, potature e manutenzioni, senza bisogno di patente C.",
    image: "/images/mezzi/snake2413-1.jpg",
    imagePosition: "center 85%",
    accent: "#0D6EFD",
  },
};

export const FLEET = [
  {
    slug: "escavatore-wacker-neuson-ez17",
    category: "movimento-terra",
    type: "Miniescavatore",
    brand: "Wacker Neuson",
    model: "EZ17",
    name: "Escavatore Wacker Neuson EZ17",
    image: "/images/mezzi/ez17.jpg",
    imagePosition: "center 60%",
    gallery: [
      { src: "/images/mezzi/ez17.jpg", alt: "Wacker Neuson EZ17 con tettuccio" },
      { src: "/images/mezzi/wn-lineup.jpg", alt: "La flotta di escavatori Wacker Neuson DESP" },
    ],
    highlight: { label: "Peso operativo", value: "1,7 t" },
    tags: ["Coda zero", "Passa da 1 m", "Cingoli gomma"],
    summary:
      "Il miniescavatore più compatto della flotta: carro allargabile da 99 cm, perfetto per giardini, cortili e passaggi stretti.",
    specs: [
      { label: "Peso operativo", value: "1.700 kg" },
      { label: "Profondità di scavo", value: "2,36 m" },
      { label: "Altezza di scarico", value: "2,55 m" },
      { label: "Larghezza carro", value: "0,99 – 1,29 m" },
      { label: "Motore", value: "Diesel Yanmar 13,4 kW" },
      { label: "Coda", value: "Zero tail" },
    ],
  },
  {
    slug: "escavatore-wacker-neuson-ez26",
    category: "movimento-terra",
    type: "Miniescavatore",
    brand: "Wacker Neuson",
    model: "EZ26",
    name: "Escavatore Wacker Neuson EZ26",
    image: "/images/mezzi/ez26.jpg",
    imagePosition: "center 60%",
    gallery: [
      { src: "/images/mezzi/ez26.jpg", alt: "Wacker Neuson EZ26 con cabina chiusa" },
      { src: "/images/mezzi/wn-lineup.jpg", alt: "La flotta di escavatori Wacker Neuson DESP" },
    ],
    highlight: { label: "Peso operativo", value: "2,6 t" },
    tags: ["Coda zero", "Cabina", "Cingoli gomma"],
    summary:
      "Il compromesso ideale tra compattezza e forza di scavo: coda zero, cabina chiusa e ottima stabilità.",
    specs: [
      { label: "Peso operativo", value: "2.600 kg" },
      { label: "Profondità di scavo", value: "2,83 m" },
      { label: "Altezza di scarico", value: "3,05 m" },
      { label: "Larghezza carro", value: "1,50 m" },
      { label: "Motore", value: "Diesel Yanmar 15,2 kW" },
      { label: "Coda", value: "Zero tail" },
    ],
  },
  {
    slug: "escavatore-wacker-neuson-ez36",
    category: "movimento-terra",
    type: "Escavatore compatto",
    brand: "Wacker Neuson",
    model: "EZ36",
    name: "Escavatore Wacker Neuson EZ36",
    image: "/images/mezzi/wn-lineup.jpg",
    imagePosition: "center 60%",
    highlight: { label: "Peso operativo", value: "3,7 t" },
    tags: ["Coda zero", "Cabina", "Braccio lungo"],
    summary:
      "Escavatore da 3,7 tonnellate a coda zero: potenza da cantiere con l'agilità dei compatti.",
    specs: [
      { label: "Peso operativo", value: "3.700 kg" },
      { label: "Profondità di scavo", value: "3,40 m" },
      { label: "Altezza di scarico", value: "3,60 m" },
      { label: "Larghezza carro", value: "1,74 m" },
      { label: "Motore", value: "Diesel Yanmar 18,2 kW" },
      { label: "Coda", value: "Zero tail" },
    ],
  },
  {
    slug: "escavatore-wacker-neuson-ez50",
    category: "movimento-terra",
    type: "Escavatore compatto",
    brand: "Wacker Neuson",
    model: "EZ50",
    name: "Escavatore Wacker Neuson EZ50",
    image: "/images/mezzi/ez50.jpg",
    imagePosition: "center 55%",
    gallery: [
      { src: "/images/mezzi/ez50.jpg", alt: "Wacker Neuson EZ50 nel piazzale DESP" },
      { src: "/images/mezzi/wn-lineup.jpg", alt: "La flotta di escavatori Wacker Neuson DESP" },
    ],
    highlight: { label: "Peso operativo", value: "4,9 t" },
    tags: ["Coda zero", "Cabina", "Alta potenza"],
    summary:
      "Il più potente della gamma: 5 tonnellate per sbancamenti, fondazioni e scavi profondi.",
    specs: [
      { label: "Peso operativo", value: "4.900 kg" },
      { label: "Profondità di scavo", value: "3,60 m" },
      { label: "Altezza di scarico", value: "4,10 m" },
      { label: "Larghezza carro", value: "1,99 m" },
      { label: "Motore", value: "Diesel Perkins 28 kW" },
      { label: "Coda", value: "Zero tail" },
    ],
  },
  {
    slug: "dumper-wacker-neuson-dt05",
    category: "movimento-terra",
    type: "Dumper cingolato",
    brand: "Wacker Neuson",
    model: "DT05",
    name: "Dumper cingolato Wacker Neuson DT05",
    image: "/images/dumper.jpg",
    highlight: { label: "Portata", value: "500 kg" },
    tags: ["Cingolato", "Largh. 69 cm", "Passa dalle porte"],
    summary:
      "Motocarriola cingolata da 500 kg: trasporta materiali dove nessun altro mezzo arriva.",
    specs: [
      { label: "Portata utile", value: "500 kg" },
      { label: "Larghezza", value: "0,69 m" },
      { label: "Peso", value: "≈ 400 kg" },
      { label: "Motore", value: "Benzina Honda" },
      { label: "Ribaltamento", value: "Idraulico frontale" },
      { label: "Trazione", value: "Cingoli in gomma" },
    ],
  },
  {
    slug: "minipala-gehl-3825",
    category: "movimento-terra",
    type: "Minipala compatta",
    brand: "Gehl",
    model: "3825",
    name: "Minipala Gehl 3825",
    image: "/images/mezzi/web-gehl.jpg",
    credit: "Mailtosap, Wikimedia Commons, CC BY-SA 4.0 (immagine rappresentativa)",
    highlight: { label: "Portata operativa", value: "385 kg" },
    tags: ["Skid steer", "Benna", "Compatta"],
    summary:
      "Skid steer compatta per carico, livellamento e pulizia cantiere in spazi ridotti.",
    specs: [
      { label: "Portata operativa", value: "385 kg" },
      { label: "Peso operativo", value: "≈ 1.150 kg" },
      { label: "Larghezza", value: "1,19 m" },
      { label: "Altezza", value: "1,75 m" },
      { label: "Motore", value: "Diesel 18 kW" },
      { label: "Attrezzatura", value: "Benna standard" },
    ],
  },
  {
    slug: "scissor-genie-gs-2032",
    category: "sollevamento",
    type: "Piattaforma a forbice",
    brand: "Genie",
    model: "GS-2032",
    name: "Piattaforma a forbice Genie GS-2032",
    image: "/images/mezzi/web-genie-gs2032.jpg",
    credit: "Tiia Monto, Wikimedia Commons, CC BY-SA 4.0 (immagine rappresentativa)",
    highlight: { label: "Altezza di lavoro", value: "8,1 m" },
    tags: ["Elettrica", "Largh. 81 cm", "Interni"],
    summary:
      "Forbice elettrica ultra-stretta da 81 cm: passa dalle porte standard e lavora fino a 8 metri in silenzio.",
    specs: [
      { label: "Altezza di lavoro", value: "8,10 m" },
      { label: "Altezza piattaforma", value: "6,10 m" },
      { label: "Portata", value: "363 kg" },
      { label: "Larghezza", value: "0,81 m" },
      { label: "Peso", value: "≈ 1.900 kg" },
      { label: "Alimentazione", value: "Elettrica 24 V" },
    ],
  },
  {
    slug: "scissor-genie-gs-2646",
    category: "sollevamento",
    type: "Piattaforma a forbice",
    brand: "Genie",
    model: "GS-2646",
    name: "Piattaforma a forbice Genie GS-2646",
    image: "/images/mezzi/web-genie-gs1930.jpg",
    imagePosition: "center 40%",
    credit: "PvOberstein, Wikimedia Commons, CC0 (immagine rappresentativa)",
    highlight: { label: "Altezza di lavoro", value: "9,9 m" },
    tags: ["Elettrica", "Portata 454 kg", "Estensione"],
    summary:
      "Piattaforma spaziosa con estensione: fino a 10 metri con 454 kg di portata per 2 operatori e materiale.",
    specs: [
      { label: "Altezza di lavoro", value: "9,92 m" },
      { label: "Altezza piattaforma", value: "7,92 m" },
      { label: "Portata", value: "454 kg" },
      { label: "Larghezza", value: "1,17 m" },
      { label: "Peso", value: "≈ 2.200 kg" },
      { label: "Alimentazione", value: "Elettrica 24 V" },
    ],
  },
  {
    slug: "scissor-jcb-s2632e",
    category: "sollevamento",
    type: "Piattaforma a forbice",
    brand: "JCB",
    model: "S2632E",
    name: "Piattaforma a forbice JCB S2632E",
    image: "/images/mezzi/web-jcb-s1930e.jpg",
    credit: "Wasiul Bahar, Wikimedia Commons, CC BY-SA 4.0 (immagine rappresentativa)",
    units: 2,
    highlight: { label: "Altezza di lavoro", value: "9,9 m" },
    tags: ["Elettrica", "2 unità", "Largh. 81 cm"],
    summary:
      "Due unità disponibili: forbice elettrica stretta da 10 metri, ideale per capannoni e impiantistica.",
    specs: [
      { label: "Altezza di lavoro", value: "9,90 m" },
      { label: "Altezza piattaforma", value: "7,90 m" },
      { label: "Portata", value: "320 kg" },
      { label: "Larghezza", value: "0,81 m" },
      { label: "Peso", value: "≈ 2.150 kg" },
      { label: "Alimentazione", value: "Elettrica 24 V" },
    ],
  },
  {
    slug: "piattaforma-oil-steel-2112-daily",
    category: "sollevamento",
    type: "Piattaforma autocarrata",
    brand: "Oil&Steel",
    model: "Snake 2112",
    name: "Piattaforma Oil&Steel Snake 2112 su Iveco Daily",
    image: "/images/autocarrata.jpg",
    highlight: { label: "Altezza di lavoro", value: "21 m" },
    tags: ["Patente B", "Articolata", "Su Iveco Daily"],
    summary:
      "Piattaforma articolata da 21 metri su Iveco Daily 3,5 t: si guida con patente B e arriva ovunque.",
    specs: [
      { label: "Altezza di lavoro", value: "21,0 m" },
      { label: "Sbraccio laterale", value: "12,0 m" },
      { label: "Portata cestello", value: "230 kg" },
      { label: "Rotazione torretta", value: "360°" },
      { label: "Veicolo", value: "Iveco Daily 3,5 t" },
      { label: "Patente", value: "B" },
    ],
  },
  {
    slug: "piattaforma-oil-steel-189-isuzu",
    category: "sollevamento",
    type: "Piattaforma autocarrata",
    brand: "Oil&Steel",
    model: "189",
    name: "Piattaforma Oil&Steel 189 su Isuzu",
    image: "/images/mezzi/oilsteel-basket.jpg",
    imagePosition: "center 35%",
    units: 3,
    highlight: { label: "Altezza di lavoro", value: "18 m" },
    tags: ["Patente B", "3 unità", "Su Isuzu"],
    summary:
      "Tre unità disponibili: telescopica da 18 metri su Isuzu, la scelta più richiesta per manutenzioni e facciate.",
    specs: [
      { label: "Altezza di lavoro", value: "18,0 m" },
      { label: "Sbraccio laterale", value: "9,0 m" },
      { label: "Portata cestello", value: "200 kg" },
      { label: "Rotazione torretta", value: "360°" },
      { label: "Veicolo", value: "Isuzu 3,5 t" },
      { label: "Patente", value: "B" },
    ],
  },
  {
    slug: "piattaforma-oil-steel-snake-2413-daily",
    category: "sollevamento",
    type: "Piattaforma autocarrata",
    brand: "Oil&Steel",
    model: "Snake 2413",
    name: "Piattaforma Oil&Steel Snake 2413 su Iveco Daily",
    image: "/images/mezzi/snake2413-1.jpg",
    imagePosition: "center 68%",
    gallery: [
      { src: "/images/mezzi/snake2413-1.jpg", alt: "Oil&Steel Snake 24 su Iveco Daily, vista laterale" },
      { src: "/images/mezzi/snake2413-2.jpg", alt: "Cestello con comandi della Snake 24" },
      { src: "/images/mezzi/snake2413-3.jpg", alt: "Braccio Snake 24 e quadro comandi a terra" },
      { src: "/images/mezzi/snake2413-4.jpg", alt: "Torretta di rotazione e pianale" },
      { src: "/images/mezzi/snake2413-5.jpg", alt: "Centralina Oil&Steel e cabina Iveco Daily" },
    ],
    highlight: { label: "Altezza di lavoro", value: "24 m" },
    tags: ["Patente B", "Articolata", "La più alta"],
    summary:
      "La più alta della flotta: 24 metri di altezza e 13 di sbraccio, sempre con patente B.",
    specs: [
      { label: "Altezza di lavoro", value: "24,0 m" },
      { label: "Sbraccio laterale", value: "13,0 m" },
      { label: "Portata cestello", value: "230 kg" },
      { label: "Rotazione torretta", value: "360°" },
      { label: "Veicolo", value: "Iveco Daily 3,5 t" },
      { label: "Patente", value: "B" },
    ],
  },
];

export const getVehicle = (slug) => FLEET.find((v) => v.slug === slug);
export const byCategory = (cat) => FLEET.filter((v) => v.category === cat);
